import { UnisexIcon } from '@/components/Icons';

type CaregiverAvatarProps = {
    photoUrl?: string;
    size?: number;
};

export const CaregiverAvatar = ({
    photoUrl,
    size = 50,
}: CaregiverAvatarProps) => {
    const imgStyle = {
        width: size,
        height: size,
    };

    if (photoUrl && photoUrl.length > 0) {
        return (
            <img
                src={photoUrl}
                alt=""
                aria-hidden="true"
                style={imgStyle}
                className="shrink-0 rounded-full object-cover"
            />
        );
    }

    return (
        <UnisexIcon className="h-[50px] w-[50px] shrink-0 rounded-full object-cover" />
    );
};
